import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

export default function ZipCodeInputCreator(type) {
  class ZipCodeInput extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.type === prevState.type) {
        return null;
      }

      return {
        value: '',
      };
    }

    constructor() {
      super();

      this.state = {
        value: '',
      };
    }

    handleChange(e) {
      const { value } = e.target;
      const valueWithoutDashes = value.split('-').join('');

      if (type === 'american' && valueWithoutDashes.length === 10) {
        return;
      }

      if (type === 'canadian' && valueWithoutDashes.length === 7) {
        return;
      }

      this.setState({
        value: valueWithoutDashes,
      });
      this.props.handleChange(valueWithoutDashes);
    }

    render() {
      const { handleBlur } = this.props;
      const { value } = this.state;
      let displayValue = '';

      for (let idx = 0; idx < value.length; idx += 1) {
        if (type === 'american' && idx === 5) {
          displayValue += '-';
        }
        displayValue += value[idx];
      }

      return (
        <Input
          invalid={this.props.invalid}
          type="text"
          value={displayValue}
          placeholder={
            type === 'american'
              ? 'Please enter a 5 or 9 digit ZIP Code'
              : 'Please enter a Postal Code'
          }
          onChange={e => this.handleChange(e)}
          onBlur={handleBlur}
        />
      );
    }
  }
  ZipCodeInput.propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
  };
  return ZipCodeInput;
}



// WEBPACK FOOTER //
// ./src/components/FormBuilder/CustomInputs/ZipCode.jsx